import React, { useState } from 'react';
import { FaMagic } from 'react-icons/fa';

const API_BASE_URL = 'https://convert.pepodins.com';

function ConvertToGif({ videoUrl, onConversionStart, onConversionProgress, onConversionComplete, onError }) {
  const [converting, setConverting] = useState(false);

  const convertToGif = async () => {
    setConverting(true);
    onConversionStart?.();

    try {
      const videoResponse = await fetch(videoUrl);
      const videoBlob = await videoResponse.blob();

      const formData = new FormData();
      formData.append('video', videoBlob, 'video.mp4');
      formData.append('startTime', 0);
      formData.append('duration', 5);
      formData.append('quality', 5);
      formData.append('maxWidth', 400);
      formData.append('outputFormat', 'gif');

      const response = await fetch(`${API_BASE_URL}/convert`, {
        method: 'POST',
        body: formData
      });

      if (!response.ok) {
        throw new Error('Conversion failed to start');
      }

      const data = await response.json();
      checkStatus(data.id);

    } catch (err) {
      onError?.(err.message);
      setConverting(false);
    }
  };

  const checkStatus = async (id) => {
    try {
      const response = await fetch(`${API_BASE_URL}/status/${id}`);
      const data = await response.json();

      onConversionProgress?.(data.progress, data.status);

      if (data.state === 'completed') {
        onConversionComplete?.({
          gifUrl: `${API_BASE_URL}/result/${id}`,
          downloadUrl: `${API_BASE_URL}/download/${id}`
        });
        setConverting(false);
      } else if (data.state === 'error') {
        throw new Error(data.error || 'Conversion failed');
      } else {
        setTimeout(() => checkStatus(id), 1000);
      }
    } catch (err) {
      onError?.(err.message);
      setConverting(false);
    }
  };

  return (
    <button
      onClick={convertToGif}
      className="action-button secondary"
      disabled={converting}
    >
      <FaMagic /> {converting ? 'Converting...' : 'Convert to GIF Loop'}
    </button>
  );
}

export default ConvertToGif; 